<template>
    <div>
        <van-nav-bar title="积分任务" right-text="签到规则" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="calendar-box">
                <div class="back-img">
                    <div class="myJiFen">
                        <img src="../../assets/shopping-icon/jifen.png" alt="" />
                        <p>我的积分</p>
                    </div>
                    <div class="top-box">
                        <p class="count">{{ userPoint }}</p>
                        <div class="history">
                            <img src="../../assets/shopping-icon/recode-icon.png" alt="" />
                            <p @click="openPointRecord">记录</p>
                        </div>
                    </div>
                    <div class="mainBox">
                        <vue-calendar :point="sign_nums" :markDate="arr" :markDateMore="arr2" :futureDayHide="now"
                            @choseDay="clickDay" @signToday="signToday"></vue-calendar>
                    </div>
                </div>
                <div class="task">
                    <div class="daily-task">
                        <div class="task_box_title">每日任务</div>
                        <ul>
                            <li v-for="(item, i) in dailyTaskList" :key="i">
                                <div class="task_box_left" v-if="item.icon">
                                    <img :src="item.icon" alt="" />
                                    <div class="task_title_des">
                                        <div class="task_title">{{ item.mission_name }}</div>
                                        <div class="task_des">{{ item.describe }}</div>
                                    </div>
                                </div>
                                <div class="task_box_left other" v-else>
                                    <div class="task_title other_title">
                                        {{ item.mission_name }}
                                    </div>
                                    <div class="task_des other_desc">{{ item.describe }}</div>
                                </div>
                                <div class="task_box_right" v-if="percent(item.finishTimes, item.times) < 100">
                                    <div class="progress_text">
                                        {{ item.finishTimes == null ? "0" : item.finishTimes }}/{{
                        item.times
                      }}
                                    </div>
                                    <div class="task_progress">
                                        <div class="progress" :style="{
                          width: percent(item.finishTimes, item.times) + '%',
                        }"></div>
                                    </div>
                                </div>
                                <div class="task_box_right completed" v-else>已完成</div>
                            </li>
                        </ul>
                    </div>
                    <div class="daily-recode">
                        <div class="task_box_title">每日任务</div>
                        <ul>
                            <li v-for="(item, i) in monthlyTaskList" :key="i">
                                <div style="
                              width: 0.3rem;
                              height: 0.3rem;
                              border-radius: 0.3rem;
                              background-color: #670000;
                            "></div>
                                <div class="task_box_left" v-if="item.icon">
                                    <img v-lazy="item.icon" alt="" />
                                    <div class="task_title_des">
                                        <div class="task_title">{{ item.mission_name }}</div>
                                        <div class="task_des">{{ item.describe }}</div>
                                    </div>
                                </div>
                                <div class="task_box_left other" v-else>
                                    <div class="task_title other_title">
                                        {{ item.mission_name }}
                                    </div>
                                    <div class="task_des other_desc">{{ item.describe }}</div>
                                </div>
                                <div class="task_box_right" v-if="percent2(item.finishTimes, item.times) < 100">
                                    <div class="progress_text">
                                        {{ item.finishTimes == null ? "0" : item.finishTimes }}/{{ num(item.times)}}
                                    </div>
                                    <div class="task_progress">
                                        <div class="progress" :style="{
                          width: percent2(item.finishTimes, item.times) + '%',
                        }"></div>
                                    </div>
                                </div>
                                <div class="task_box_right completed" v-else>已完成</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </van-pull-refresh>

        <!-- 补签弹框 -->
        <div class="rp_bg" v-if="showReissuePopup"></div>
        <div class="reissue-popup" v-if="showReissuePopup">
            <div class="reissue-popup-title">补签提醒</div>
            <div class="reissue-popup-content">本月当前剩余{{freeReissue}}次免费补签, {{paidReissue}}次积分补签，是否补签?</div>
            <div class="reissue-popup-btns">
                <Button class="rp_btn2" @click="closeReissuePopup">取消</Button>
                <Button :loading="loading > 0" class="rp_btn1" @click="reissue">补签</Button>
            </div>
        </div>

        <!-- 积分获取记录 弹框-->
        <div class="getPoint_record" v-if="showGetPointRecord">
            <div class="bg" @click="closePointRecord"></div>
            <div class="content">
                <div class="gr-title">
                    获取记录
                    <van-icon name="cross" @click="closePointRecord" />
                </div>
                <div class="gr-content">
                    <ul class="list gr-content-title">
                        <li>
                            <span>日期</span>
                            <span>详情</span>
                            <span>积分</span>
                        </li>
                    </ul>
                    <ul class="list gr-list">
                        <data-list url="point/customer-point-log" :limit="5" show-empty show-pages>
                            <template slot-scope="scope">
                                <li v-for="row of scope.data">
                                    <span v-if="row.create_time">{{row.create_time.slice(0,10)}}</span>
                                    <span>{{row.text}}</span>
                                    <span>{{row.type == 1 ? '+' : '-'}}{{row.point}}</span>
                                </li>
                            </template>
                        </data-list>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                userPoint: 0,
                //每日任务列表
                dailyTaskList: [],
                //累计任务列表
                monthlyTaskList: [],
                sign_nums: 0,
                // 可以补签
                arr: [],
                // mark2签到过
                arr2: [],
                // 免费补签次数
                freeReissue: 0,
                // 付费签到次数
                paidReissue: 0,
                time: null,
                showReissuePopup: false,
                loading: 0,
                showGetPointRecord: false, //积分记录
            };
        },
        computed: {
            //服务器时间
            now() {
                return (((new Date(new Date().valueOf() - this.$store.state.differTime)).getTime()) / 1000).toString();
            },
        },
        created() {},
        mounted() {
            this.getUserInfoAPI1();
            this.getSignInList()
            this.getDailyTaskList();
            this.getMonthlyTaskList();
        },
        methods: {
            onClickRight() {
                this.$router.push({
                    name: "user.PointStatement"
                });
            },
            num(str) {
                var arr = str.split(",");
                return arr[arr.length - 1];
            },
            percent(num1, num2) {
                if (num1 == null) {
                    num1 = 0;
                }
                return (Number(num1) / Number(num2)) * 100;
            },
            percent2(num1, num2) {
                if (num1 == null) {
                    num1 = 0;
                }
                var arr = num2.split(",");
                num2 = arr[arr.length - 1];
                return (Number(num1) / Number(num2)) * 100;
            },
            //积分
            getUserInfoAPI1() {
                this.$Ajax("/my/user-center", {}).then((res) => {
                    //用户积分
                    this.userPoint = res.data.point;
                });
            },

            // 获取日历 可补签  已签到  以及  次数
            getSignInList() {
                this.$Ajax("point/sign-in-list").then(rs => {
                    if (rs.code == 200) {
                        this.sign_nums = rs.data.sign_nums
                        this.freeReissue = rs.data.free_reissue;
                        this.paidReissue = rs.data.paid_reissue;
                        // reissueTime 可以补签的日期
                        this.arr = [];
                        this.arr = rs.data.reissueTime;
                        //signinTime 签到过的日期
                        var signinTime = rs.data.signinTime;
                        if (signinTime.length != 0) {
                            var lastSignDay = new Date(signinTime[signinTime.length - 1]).toDateString()
                            var today = new Date().toDateString()
                        }
                        this.arr2 = [];
                        for (var i = 0; i < signinTime.length; i++) {
                            this.arr2.push({
                                date: signinTime[i],
                                className: "mark2"
                            });
                        }
                    }
                });
            },
            //点击日历补签 弹出补签弹框
            clickDay(day) {
                var date = this.addZero(day);
                this.time = Math.round(new Date(date).getTime() / 1000);
                var canClick = this.arr.indexOf(date);
                if (canClick > -1) {
                    this.openReissuePopup();
                }
            },
            //打开补签弹框
            openReissuePopup() {
                this.showReissuePopup = true
            },
            //关闭补签弹框
            closeReissuePopup() {
                this.showReissuePopup = false
            },
            //补签弹框 补签按钮
            reissue() {
                this.loading++;
                this.$Ajax("point/reissue", {
                    reissue_time: this.time
                }).then(rs => {
                    if (rs.code == 200) {
                        this.$toast('补签成功')
                        //刷新积分
                        this.getUserInfoAPI1();
                        this.getSignInList();
                        this.getDailyTaskList()
                        this.getMonthlyTaskList()
                        this.closeReissuePopup();
                    }
                }).finally(() => {
                    this.loading--;
                });
            },
            signToday() {
                this.$Ajax('point/sign-in').then(rs => {
                    if (rs.code == 200) {
                        this.$toast('签到成功')
                        //刷新积分
                        this.getUserInfoAPI1();
                        this.getSignInList();
                        this.getDailyTaskList()
                        this.getMonthlyTaskList()
                    }
                })
            },
            //加0
            addZero(date) {
                var arr = date.split("/");
                var num1 = arr[1];
                var num2 = arr[2];
                if (num1.length < 2) {
                    num1 = "0" + num1;
                }
                if (num2.length < 2) {
                    num2 = "0" + num2;
                }
                return arr[0] + "/" + num1 + "/" + num2;
            },
            // 获取每日任务列表
            getDailyTaskList() {
                this.$Ajax("point/daily-task-list").then((rs) => {
                    if (rs.code == 200) {
                        this.dailyTaskList = rs.data;
                    }
                });
            },

            // 获取每月累计任务列表
            getMonthlyTaskList() {
                this.$Ajax("point/monthly-task-list").then((rs) => {
                    if (rs.code == 200) {
                        this.monthlyTaskList = rs.data;
                    }
                });
            },
            //打开 积分获取列表弹框
            openPointRecord() {
                this.showGetPointRecord = true
            },
            //关闭 积分获取列表弹框
            closePointRecord() {
                this.showGetPointRecord = false
            }
            // //获取积分记录详情
            // getPointRecode(page) {
            //     this.$Ajax("point/customer-point-log", {
            //         page
            //     }).then((rs) => {
            //         this.totalItems = rs.data.page_info.total
            //     });
            // },
        },
    };
</script>
<style lang="less" scoped>
    :deep(.van-nav-bar__text) {
        font-weight: 400;
        color: #9e9e9e;
    }

    .calendar-box {
        margin-top: 2.5rem;

        .back-img {
            min-height: 10rem;
            width: 100%;
            background-image: url("../../assets/shopping-icon/pointstask-bg.png");
            background-repeat: no-repeat;
            background-size: 100% 10rem;

            .myJiFen {
                padding-left: 0.75rem;
                padding-top: 1.1rem;
                padding-bottom: 0.6rem;
                display: flex;
                align-items: center;
                gap: 0.25rem;

                img {
                    width: 0.85rem;
                    height: 0.8rem;
                }

                p {
                    color: #ffffff;
                }
            }

            .top-box {
                display: flex;
                justify-content: space-between;

                .count {
                    margin-left: 1.85rem;
                    font-size: 1.2rem;
                    font-weight: bold;
                    color: #ffffff;
                    line-height: 1.2rem;
                }

                .history {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 0.2rem;
                    margin-right: 0.75rem;
                    width: 2.75rem;
                    height: 1.3rem;
                    background-color: #ffffff88;
                    color: #ffffff;
                    border-radius: 1rem;
                    font-size: 0.6rem;

                    img {
                        width: 0.5rem;
                        height: 0.5rem;
                    }

                    .record-pop {
                        border-radius: 0.7rem;
                        padding: 0.5rem 0.6rem;

                        .main {
                            .title {
                                text-align: center;
                                font-size: 0.8rem;
                            }
                        }

                        .van-pagination {
                            gap: 0.25rem;

                            :deep(.van-pagination__item) {
                                height: 1.25rem;
                                min-width: 1.25rem;
                                font-size: 0.6rem;
                            }
                        }
                    }
                }
            }
        }

        .mainBox {
            // margin: 1.1rem 0.75rem 0;
            border-radius: 0.7rem;
            overflow: hidden;
            margin-top: 1rem;
        }
    }

    .task {
        .daily-task {
            margin: 0.65rem 0.75rem 0.6rem;
            background-color: #ffffff;
            border-radius: 0.7rem;
            padding: 0.6rem;

            ul {
                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.75rem;
                }
            }

            .task_box_left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 0.45rem;

                img {
                    width: 1rem;
                    height: 0.85rem;
                }
            }
        }

        .completed {
            width: 3.15rem;
            height: 1.4rem;
            text-align: center;
            line-height: 1.4rem;
            background: #f3f2f2;
            border-radius: 1rem;
            color: #9e9e9e;
            font-size: 0.6rem;
        }

        .task_title {
            color: #000000;
            font-size: 0.6rem;
        }

        .task_des {
            color: #9e9e9e;
            font-size: 0.5rem;
        }

        .progress_text {
            font-size: 0.6rem;
            color: #9e9e9e;
            text-align: center;
        }

        .task_progress {
            width: 3.15rem;
            height: 0.25rem;
            background-color: #e4e4e4;
            border-radius: 10rem;
            overflow: hidden;

            .progress {
                height: 0.25rem;
                background-color: #670000;
            }
        }

        .task_box_title {
            color: #000000;
            font-weight: bold;
            margin-bottom: 0.5rem;
        }

        .daily-recode {
            margin: 0.65rem 0.75rem 1rem;
            background-color: #ffffff;
            border-radius: 0.7rem;
            padding: 0.6rem;

            ul {
                li {
                    gap: 0.3rem;
                    display: flex;
                    align-items: center;
                    margin-bottom: 1rem;

                    .task_box_left {
                        flex: 1;
                    }
                }
            }
        }
    }

    .rp_bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 99;
    }

    //补签弹框
    .reissue-popup {
        position: fixed;
        top: 9.4rem;
        left: 50%;
        z-index: 100;
        transform: translateX(-50%);
        width: 13rem;
        height: 12rem;
        padding: 1.1rem;
        border-radius: .9rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #fff;

        .reissue-popup-title {
            font-size: 1rem;
            color: #000;
            font-weight: 700;
            margin-bottom: 1.2rem;
        }

        .reissue-popup-content {
            font-size: .7rem;
            color: #000;
            text-align: center;
            line-height: 2;
            margin-bottom: 1.45rem;
        }

        .reissue-popup-btns {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .rp_btn2 {
                width: 4.9rem;
                height: 1.7rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #9e9e9e;
                border: 1px solid #9e9e9e;
                border-radius: 10rem;
                font-size: .7rem;

                &:active {
                    opacity: 0.8;
                }
            }

            .rp_btn1 {
                margin-left: 1rem;
                width: 4.9rem;
                height: 1.7rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background-color: #000;
                border: 1px solid #000;
                border-radius: 10rem;
                font-size: .7rem;

                &:active {
                    opacity: 0.8;
                }
            }
        }
    }


    // 积分获取记录 弹框
    .getPoint_record {
        .bg {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1001;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
        }

        .content {
            position: fixed;
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1002;
            background-color: #fff;
            width: 88%;
            max-width: 400px;
            border-radius: 12px;
            overflow: hidden;

            .gr-title {
                text-align: center;
                position: relative;
                font-size: 1rem;
                font-weight: 700;
                color: #000;
                padding: .8rem 0;

                .van-icon {
                    position: absolute;
                    right: .8rem;
                    top: 0.8rem;
                    font-size: 1rem;
                    font-weight: 700;
                    cursor: pointer;
                }
            }

            .gr-content {
                padding: 0 .6rem .6rem;

                .list {
                    li {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        span {
                            flex: 1;
                            text-align: center;
                        }
                    }

                    &.gr-content-title {
                        color: #000;
                        font-size: .75rem;
                        font-weight: 700;
                        margin-bottom: .4rem;
                    }

                    &.gr-list {
                        color: #9e9e9e;
                        max-height: 346px;

                        li {
                            padding: .4rem 0;
                            margin-bottom: 4px;
                            border-bottom: 1px solid #a6a6a6;
                            font-size: .6rem;
                        }
                    }
                }
            }

            .ivu-page {
                margin-bottom: 0;
                display: flex;

                li {
                    margin: 0;
                    padding-bottom: 0;
                    transform: scale(0.8);
                    transform-origin: center center;

                    a {
                        width: 100%;
                        height: 100%;
                    }
                }

                .ivu-page-item-jump-next,
                .ivu-page-item-jump-prev {
                    border: 1px solid #dcdee2;

                    &::after {
                        width: 100%;
                        transform: translateX(-6px);
                    }
                }
            }
        }
    }
</style>